module.exports = __webpack_public_path__ + "static/epitome-eula-banner-edb9d0a1bfe3291f9eb7fac1996f9f16.png";